import { FC, ReactNode } from 'react';

import { Box, SxProps, Theme } from '@mui/material';

interface CenteredLayoutProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Layout component that centers content with top margin.
 * Used for pages that need centered content presentation.
 */
export const CenteredLayout: FC<CenteredLayoutProps> = ({ children, sx }) => (
  <Box
    sx={[
      {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        mt: '4vh'
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : [])
    ]}
  >
    {children}
  </Box>
);
